import React, { Component } from 'react';
import { connect } from 'react-redux';

import 'bootstrap/dist/css/bootstrap.min.css';

import '../styles/App.css';
import Square from './Square';
import Button from './Button';
import Overlay from './Overlay';
import SvgDefs from './SvgDefs';
import Editor from './Editor';

import { setSquares, setLevel, setLevelID, setMoves } from '../actions';
import { fieldMap } from '../utilities';

const BOARD_SIZE = 729;
const FULL_SIZE = BOARD_SIZE / 12;

function squareSizer(square) {
  if (square.depth === 1) {
    return FULL_SIZE * 1.0;
  }
  else if (square.depth === 2) {
    return FULL_SIZE * 0.80;
  }
  else if (square.depth === 3) {
    return FULL_SIZE * 0.60;
  }
}

function squareOffset(x, y, square) {
  let size  = squareSizer(square);

  return `translate(${x + ( FULL_SIZE - size ) / 2},${y + (FULL_SIZE - size) / 2})`;
}

class App extends Component {

  isVisible(tool) {
    return this.props.tool.available[tool] > 0
  }

  renderTool(tool, numAvailable, offset) {
    let width = 24;
    let height = width * 1.5;
    return <g transform={`translate(  ${offset},0)`} key={`${tool}_group`}><Button width={width} height = {height} badge = {numAvailable}  icon = {tool}  tool={tool}  field={fieldMap[tool]}     /></g>
  }

  renderTools() {
    const availableTools = this.props.tool.available;

    var tools = Object.keys(availableTools).sort().filter( t => availableTools[t] > 0 );

    // the rightmost tool should be offset by 111px, and we increment the counter before rendering. So we go 37 beyond it.
    // 37 is the magic number for the width of the tool + 5px padding. 111px is the magic number to make it fit properly in the square.
    var buttonWithPaddingWidth = 26;
    var offset = 122 + buttonWithPaddingWidth;

    return (
      <g transform='translate(93,28)' key='tools'>
        { tools.map( t => this.renderTool(t, availableTools[t], offset -= buttonWithPaddingWidth ))}
      </g>
    );

  }

  renderMatch (prop) {
    return !prop ? String.fromCharCode(10003) : String.fromCharCode(10008);
  }

  renderColor(prop) {
    return !prop ? 'green' : 'red'
  }


  render() {

    const styleOverride = this.props.editor
      ? {}
      : { width : '100vmin', height : '100vmin' }
    ;

    //if (this.props.tools === undefined) { return null }
    
    return (
      <div align='center'>
        <svg className='game' viewBox={'0 0 ' + BOARD_SIZE + ' ' + BOARD_SIZE} style={styleOverride}>

          <SvgDefs />

          <Square
            width     = { BOARD_SIZE }
            height    = { BOARD_SIZE }
            idx       = { 0 }
            square_id = { '0' }
          />

          <g style={{opacity : this.props.editor ? 0 : 100}}>
            <g transform={`translate(${BOARD_SIZE / 3},${BOARD_SIZE / 3})`}>
              <text>
                <tspan x='10' dy='1em'>Score    : <tspan x='85' className='scoreItem'>{this.props.level.points}</tspan></tspan>
                <tspan x='10' dy='1em'>Sets     : <tspan x='85' className='scoreItem'>{this.props.level.sets}</tspan></tspan>
                <tspan x='10' dy='1em'>Streak   : <tspan x='85' className='scoreItem'>{this.props.level.streak}</tspan></tspan>
                <tspan x='10' dy='1em'>Mistakes: <tspan x='85' className='scoreItem'>{this.props.level.mistakes}</tspan></tspan>
                <tspan x={BOARD_SIZE / 3 / 2} dy='1.25em' textAnchor='middle' fontWeight='bold' fontSize='150%'>
                  Level: { this.props.level.level }
                  { this.props.level.moves !== undefined && <tspan dx='25'>Moves: { this.props.level.moves }</tspan>}
                </tspan>
              </text>

              { this.renderTools() }

            </g>

            { !this.props.level.set && (
              <g transform={`translate(${BOARD_SIZE / 3},${BOARD_SIZE / 3})`}>
                <text fontSize='80%'>
                  <tspan x='10' dy='10em' fontWeight='bold'>Instructions:</tspan>
                  <tspan x='10' dy='1em'>• Make groups of 3 animals</tspan>
                  <tspan x='10' dy='1em'>• A group must have everything</tspan>
                  <tspan x='10' dy='1em'>&nbsp;&nbsp;in common, or everything different.</tspan>
                  <tspan x='10' dy='1em'>• Click animals to select them.</tspan>
                  <tspan x='10' dy='1em'>• Make a mistake and they go to</tspan>
                  <tspan x='10' dy='1em'>&nbsp;&nbsp;sleep for a while.</tspan>
                </text>
              </g>
            )}

            { this.props.level.set && (
              <g transform={`translate(${BOARD_SIZE / 3},${BOARD_SIZE / 3})`}>
                <rect x = '5' y = '5' width={BOARD_SIZE / 3 - 10} height={BOARD_SIZE / 3 - 10} fill='blue' visibility='hidden'/>
                <g transform={squareOffset(BOARD_SIZE / 48, BOARD_SIZE / 3 - 80 - BOARD_SIZE / 12,this.props.level.set.squares[0])}>
                  <Square
                    width  = { squareSizer(this.props.level.set.squares[0])}
                    height = { squareSizer(this.props.level.set.squares[0])}
                    idx    = {0}
                    square = { this.props.level.set.squares[0] }
                    immortal = { true }
                    autoPlace= { false }
                  />
                </g>
                <g transform={squareOffset(BOARD_SIZE / 48 * 2 + BOARD_SIZE / 12, BOARD_SIZE / 3 - 80 - BOARD_SIZE / 12,this.props.level.set.squares[1])}>
                  <Square
                    width  = { squareSizer(this.props.level.set.squares[1])}
                    height = { squareSizer(this.props.level.set.squares[1])}
                    idx    = {0}
                    square = { this.props.level.set.squares[1] }
                    immortal = { true }
                    autoPlace= { false }
                  />
                </g>
                <g transform={squareOffset(BOARD_SIZE / 48 * 3 + BOARD_SIZE / 12 * 2,BOARD_SIZE / 3 - 80 - BOARD_SIZE / 12,this.props.level.set.squares[2])}>
                  <Square
                    width  = { squareSizer(this.props.level.set.squares[2])}
                    height = { squareSizer(this.props.level.set.squares[2])}
                    idx    = {0}
                    square = { this.props.level.set.squares[2] }
                    immortal = { true }
                    autoPlace= { false }
                  />
                </g>

                <g transform={`translate(0,${BOARD_SIZE / 3 - 75})`}>
                  <rect fill='darkgray' x='20' y={'0'} width={BOARD_SIZE / 3 - 40} height={'4.5em'} opacity='0.9' visibility='hidden'/>
                  <text x = {50} y = {0} textAnchor = 'left' fill='black'>
                    <tspan x='20' dy='1em'>Animal :     <tspan x = '100' fill={ this.renderColor(this.props.level.set.mismatches.animal)}>{ this.renderMatch(this.props.level.set.mismatches.animal)}</tspan> &#215; {this.props.level.set.points.animal} pts</tspan>
                    <tspan x='20' dy='1em'>Color :      <tspan x = '100' fill={ this.renderColor(this.props.level.set.mismatches.fill)}>{ this.renderMatch(this.props.level.set.mismatches.fill)}</tspan> &#215; {this.props.level.set.points.fill} pts</tspan>
                    <tspan x='20' dy='1em'>Direction :  <tspan x = '100' fill={ this.renderColor(this.props.level.set.mismatches.direction)}>{ this.renderMatch(this.props.level.set.mismatches.direction)}</tspan> &#215; {this.props.level.set.points.direction} pts</tspan>
                    <tspan x='20' dy='1em'>Size :       <tspan x = '100' fill={ this.renderColor(this.props.level.set.mismatches.depth)}>{ this.renderMatch(this.props.level.set.mismatches.depth)}</tspan> &#215; {this.props.level.set.points.depth} pts</tspan>
                  </text>
                </g>
              </g>
            )}
          </g>

        </svg>

        <Overlay level={this.props.level.success ? this.props.level.level + 1 : this.props.level.level} failed={this.props.level.failed} />

        <Editor editor={this.props.editor} />


      </div>
    );
  }
}

App.defaultProps = {
  editor : window.location.href.match(/editor=true/)
    ? true
    : false
};

const mapStateToProps = ({ level, squares, tool, goal }) => {
  let state = { level, tool }
  if (level.level === 'editor') {
    level.squares = squares;
    state.squares = squares;
  }

  return state;
}

export default connect(mapStateToProps, { setSquares, setLevel, setLevelID, setMoves })(App);



// WEBPACK FOOTER //
// ./src/components/App.js